import { Injectable } from '@angular/core';

import { doc, docData, collection, collectionData, Firestore, query, orderBy, where, limit, addDoc, updateDoc, deleteDoc, setDoc, deleteField, getDocs, collectionGroup, writeBatch, startAfter } from '@angular/fire/firestore';

import { map } from 'rxjs/operators';

import { Resource } from '../classes/index';

@Injectable()
export class ResourceService {

	constructor(private firestore: Firestore) {
	}

	listResources(collectionPath) {
		return collectionData(query(collection(this.firestore, collectionPath)), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(data => {
				delete data.collectionPath;
				let resource = new Resource(collectionPath);
				resource.fromJSON(data);
				return resource;
			});
		}))
		.pipe(map(resources => resources.sort((a, b) => {
			if (a.labels['fr'] > b.labels['fr']) return 1;
			else if (a.labels['fr'] < b.labels['fr']) return -1;
			else return 0;
		})));
	}

	getResources(collectionPath){
		return collectionData(query(collection(this.firestore, collectionPath), orderBy('orderNum', 'asc')), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(data => {
				delete data.collectionPath;
				let resource = new Resource(collectionPath);
				resource.fromJSON(data);
				return resource;
			});
		}));
	}

	addResource(resource) {
		let data = { ...resource };
		delete data.collectionPath;
		return addDoc(collection(this.firestore, resource.collectionPath), {...data});
	}

	setResource(resource) {
		let data = { ...resource };
		delete data.collectionPath;
		return setDoc(doc(this.firestore, resource.collectionPath, resource.id), data);
	}

	updateResource(resource, data){
		data.collectionPath = deleteField();
		console.log('Update object:'+resource.collectionPath+'/'+resource.id);
		console.log('DATA:'+JSON.stringify(data));
		return updateDoc(doc(this.firestore, resource.collectionPath, resource.id), data);
	}

	deleteResource(resource) {
		return deleteDoc(doc(this.firestore, resource.collectionPath, resource.id));
	}
}

